import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { useAddNotification } from 'hooks/useAddNotification'
import { campaignReviewFromServer, campaignReviewToServer, createCampaignToServer } from 'models/campaign-review-model'
import { get, post, put } from 'utils/http'

export const useCampaignReview = (id: any) =>
  useQuery({
    queryKey: ['campaignReview', id],
    queryFn: async () => campaignReviewFromServer(await get(`/management/campaigns/${id}/review`)),
    enabled: !!id,
  })

// PUT reviewed data then always invalidate (parity with the old swallowing thunk) so the caller advances the stepper regardless.
export const useUpdateCampaignReview = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, payload }: any) => put(`/management/campaigns/${id}/review`, campaignReviewToServer(payload)),
    onSettled: (_d, _e, { id }: any) => queryClient.invalidateQueries({ queryKey: ['campaignReview', id] }),
  })
}

// Create the campaign in the ad exchange (Stripe subscription + campaign); notifications + redirect reproduced here as onSuccess/onError.
export const useCreateCampaign = () => {
  const addNotification = useAddNotification()
  const navigate = useNavigate()
  return useMutation({
    mutationFn: ({ id, payload }: any) =>
      post(`/management/campaigns/${id}/ad_exchange`, createCampaignToServer(payload)),
    onSuccess: () => {
      addNotification('Campaign created successfully', 'success')
      navigate(UrlProvider.getUrl('campaigns.review'))
    },
    onError: () => addNotification('Exchange campaign creation error', 'error'),
  })
}
